var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-advanced-search',_vm._g({attrs:{"searches":_vm.searches,"attributes":_vm.attributes,"pending":_vm.pending,"allow-or":"","with-history":""}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }